import React, { useState } from 'react';
import MainLayout from '../layouts/MainLayout';
import { Box, Typography, Tab, Tabs, Paper, Avatar } from '@mui/material';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import BusinessIcon from '@mui/icons-material/Business';
import StoreIcon from '@mui/icons-material/Store';
import MwcManagement from '../components/MwcManagement';
import RantingManagement from '../components/RantingManagement';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const UnitManagementPage = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <MainLayout>
      <Box sx={{ p: 3, bgcolor: '#f5f7fa', minHeight: '100vh' }}>
        {/* HEADER */}
        <Paper elevation={0} sx={{ p: 3, mb: 4, borderRadius: 3, display: 'flex', alignItems: 'center', border: '1px solid #e0e0e0' }}>
            <Avatar sx={{ bgcolor: 'info.light', color: 'info.main', mr: 2, width: 56, height: 56 }}>
                <AccountTreeIcon fontSize="large" />
            </Avatar>
            <Box>
                <Typography variant="h5" fontWeight="bold" color="primary.main">Manajemen Unit</Typography>
                <Typography variant="body2" color="text.secondary">Kelola struktur organisasi MWC dan Ranting.</Typography>
            </Box>
        </Paper>

        <Paper sx={{ width: '100%', borderRadius: 2, boxShadow: 3 }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs 
                value={tabValue} 
                onChange={handleTabChange} 
                aria-label="Unit management tabs"
                textColor="primary"
                indicatorColor="primary"
                sx={{ px: 2, pt: 1 }}
            >
              <Tab icon={<BusinessIcon />} iconPosition="start" label="Majelis Wakil Cabang (MWC)" />
              <Tab icon={<StoreIcon />} iconPosition="start" label="Ranting" />
            </Tabs>
          </Box>
          <TabPanel value={tabValue} index={0}>
            <MwcManagement />
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            <RantingManagement />
          </TabPanel>
        </Paper>
      </Box>
    </MainLayout>
  );
};

export default UnitManagementPage;
